var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumaniseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.102,
    x2: 0,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e87f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.164,
    y1: -0.109,
    x2: -0.188,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1374",
    "data-name": "Groupe 1374",
    transform: "translate(-142 -1697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M1346.391-154.923a23.527,23.527,0,0,1-23.5-23.5,23.527,23.527,0,0,1,23.5-23.5,23.527,23.527,0,0,1,23.5,23.5A23.527,23.527,0,0,1,1346.391-154.923Zm0-45a21.524,21.524,0,0,0-21.5,21.5,21.524,21.524,0,0,0,21.5,21.5,21.525,21.525,0,0,0,21.5-21.5A21.525,21.525,0,0,0,1346.391-199.923Z",
    transform: "translate(-1180.891 1898.923)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M15.5,14.8a4.05,4.05,0,0,0-4.05,4.05v5.4a1.35,1.35,0,1,1-2.7,0V18.8a4.759,4.759,0,0,1-.675.048q-.223,0-.441-.02a1.354,1.354,0,0,1-.234.02H6.821A2.121,2.121,0,0,0,4.7,20.971V22.9a1.35,1.35,0,0,1-2.7,0V20.971a4.818,4.818,0,0,1,2.246-4.077,4.726,4.726,0,0,1,5.873-7.03q-.02-.229-.02-.464a5.4,5.4,0,0,1,10.8,0q0,.235-.02.464a4.726,4.726,0,0,1,5.873,7.03A4.818,4.818,0,0,1,29,20.971V22.9a1.35,1.35,0,0,1-2.7,0V20.971a2.121,2.121,0,0,0-2.121-2.121H23.6a1.355,1.355,0,0,1-.234-.02q-.218.02-.441.02a4.758,4.758,0,0,1-.675-.048V24.25a1.35,1.35,0,1,1-2.7,0v-5.4A4.05,4.05,0,0,0,15.5,14.8Zm0-2.7a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,15.5,12.1Zm-7.425,0A2.025,2.025,0,1,0,10.1,14.125,2.025,2.025,0,0,0,8.075,12.1Zm14.85,0a2.025,2.025,0,1,0,2.025,2.025A2.025,2.025,0,0,0,22.925,12.1Z",
    transform: "translate(150 1703.679)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumaniseIcon);
export default __webpack_public_path__ + "static/media/HumaniseIcon.010dd508be26174bc3c3d91e96503f79.svg";
export { ForwardRef as ReactComponent };